import React, { useEffect, useContext } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { AuthContext, AuthConsumer } from '../lib/contexts/AuthContext';
import { HeaderProvider } from '../contexts/HeaderContext';    

const PrinterFriendlyConfirmationReceiptLayout = (props) => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (!authContext.isAuthenticated()) {
      navigate('/login')
    }
  }, [authContext, navigate])

  return (
    <AuthConsumer>
      {context => (
        <HeaderProvider>
          <div className="container-confirmation-receipt">
            <div className="container-confirmation-receipt-main">
                {props.children}
            </div>
          </div>
        </HeaderProvider>)}
    </AuthConsumer>

  );
}

export const PrinterFriendlyConfirmationReceiptLayoutRoute = ({ component: Component, ...rest }) => { 
  return (
    <Routes>
      <Route { ...rest} element = {
        <PrinterFriendlyConfirmationReceiptLayout>
          <Component />
        </PrinterFriendlyConfirmationReceiptLayout>
      } />
    </Routes>
  )
}